var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTerre(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_573_4155)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.2355 45.8334H4.74792V41.3347C4.74792 39.0854 6.99724 36.8361 9.24655 36.8361H40.7369C42.9862 36.8361 45.2355 39.0854 45.2355 41.3347V45.8334Z",
    stroke: "#A3AED0",
    strokeWidth: 4.49863,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.496 36.8361L24.9918 3.09637",
    stroke: "#A3AED0",
    strokeWidth: 4.49863,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4877 36.8361L24.9918 3.09637",
    stroke: "#A3AED0",
    strokeWidth: 4.49863,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3685 36.8361L30.6151 31.2128",
    stroke: "#A3AED0",
    strokeWidth: 2.24931,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.496 34.5869L28.3658 25.5897",
    stroke: "#A3AED0",
    strokeWidth: 2.24931,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9945 25.5896L26.1164 19.9663",
    stroke: "#A3AED0",
    strokeWidth: 2.24931,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_573_4155"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(-0.000610352 0.59729)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerre);
export default __webpack_public_path__ + "static/media/Terre.72980c90942be2a91ce95bc1e26e6346.svg";
export { ForwardRef as ReactComponent };